/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderTrasvesti = createReactComponent("gender-trasvesti", "IconGenderTrasvesti", [
  ["path", { d: "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z", key: "svg-0" }],
  ["path", { d: "M6 6l5.4 5.4", key: "svg-1" }],
  ["path", { d: "M4 8l4 -4", key: "svg-2" }]
]);

export { IconGenderTrasvesti as default };
//# sourceMappingURL=IconGenderTrasvesti.js.map
